import { render, staticRenderFns } from "./SbolIconGlasses.vue?vue&type=template&id=29ec9e4a&scoped=true&"
import script from "./SbolIconGlasses.vue?vue&type=script&lang=js&"
export * from "./SbolIconGlasses.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolIconGlasses.vue?vue&type=style&index=0&id=29ec9e4a&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "29ec9e4a",
  null
  ,true
)

export default component.exports